import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author VSm
 * @created on Dec 31 2019
 * @copyOf packages/common-be/src/data-processing/model/DpTaskPrerequisite.ts
 */
import { DomainObject } from '@logio/common-be-fe';
export var DpTaskPrerequisite =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DpTaskPrerequisite, _DomainObject);

  // tslint:disable-next-line:prettier
  function DpTaskPrerequisite(id, optional) {
    var _this;

    _classCallCheck(this, DpTaskPrerequisite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DpTaskPrerequisite).call(this));
    _this.id = id;
    _this.optional = optional;
    return _this;
  }

  return DpTaskPrerequisite;
}(DomainObject);